"use client"

import { useAuthStore } from "@/stores/auth-store"

/**
 * Dentour 260923 — price visibility (backend: App\Support\PriceVisibility).
 *
 * Under `price_visibility_enabled`, a user without `prices.view` never sees
 * money: the API already nulls every price and 403s money-only endpoints, and
 * money permissions are missing from their permission list, so billing menus
 * and actions disappear on their own. What is left for the client is
 * rendering: every currency formatter routes through `maskPrice`, so an amount
 * — or a null the server sent in its place — reads as "—" instead of "€0".
 */
export const PRICE_MASK = "—"

type AuthUser = ReturnType<typeof useAuthStore.getState>["user"]

function hiddenFor(user: AuthUser): boolean {
  if (!user?.feature_flags?.price_visibility_enabled) return false
  return !(user.permissions ?? []).includes("prices.view")
}

/** Non-hook form, for formatters and code outside React render. */
export function pricesHidden(): boolean {
  return hiddenFor(useAuthStore.getState().user)
}

/** Reactive form for components deciding whether to render a price at all. */
export function usePricesHidden(): boolean {
  return useAuthStore((s) => hiddenFor(s.user))
}
